import React, { Component } from 'react';
import { connect } from 'react-redux';
import withRouter from '../../lib/router/withRouter';
import PageTemplate from '../../components/template/PageTemplate';
import SearchWordSaveContainer from '../../containers/searchWord/SearchWordSaveContainer';
import { searchWordActions } from '../../store/modules/searchWord';
import { SEARCH_WORD_SAVE_MODEL } from '../../store/modules/searchWord/models';
import { SEARCH_WORD_PAGE_NAME } from '../../constants/service/app/searchWordConstants';

class SearchWordEdit extends Component {
  componentDidMount() {
    const { match } = this.props;
    if (match.params.id) {
      this.initiate(Number(match.params.id));
    }
  }

  /**
   *  초기화
   */
  componentWillUnmount() {
    const { setData } = this.props;

    setData({
      path: ['searchWordSave'],
      value: SEARCH_WORD_SAVE_MODEL,
    });
  }

  /**
   * 초기 데이터 불러오기
   */
  initiate = (searchWordId) => {
    const { getSearchWordDetail } = this.props;

    getSearchWordDetail({ searchWordId });
  };

  /**
   *  편집하기
   */
  onSubmit = (data) => {
    const { editSearchWord, match } = this.props;
    const { word, relatedKeywordList } = data;

    editSearchWord({
      wordId: Number(match.params.id),
      word,
      relatedKeywordNameList: relatedKeywordList.nameList,
    });
  };

  /**
   *  검색 키워드 삭제하기
   */
  removeSearchWord = (searchWordId) => {
    const { deleteSearchWord } = this.props;

    deleteSearchWord({
      searchWordIdList: [searchWordId],
    });
  };

  render() {
    const { match } = this.props;

    return (
      <PageTemplate pageName={SEARCH_WORD_PAGE_NAME.SEARCH_WORD_EDIT}>
        <SearchWordSaveContainer
          searchWordId={match.params.id}
          onSubmit={this.onSubmit}
          removeSearchWord={this.removeSearchWord}
          isEdit={true}
        />
      </PageTemplate>
    );
  }
}

const mapDispatchToProps = {
  setData: searchWordActions.setData,
  getSearchWordDetail: searchWordActions.getSearchWordDetail,
  editSearchWord: searchWordActions.editSearchWord,
  deleteSearchWord: searchWordActions.deleteSearchWord,
};

export default connect(null, mapDispatchToProps)(withRouter(SearchWordEdit));
